/* ue-carousel.js — 슬로우레시피 공용 캐러셀
   커스텀 엘리먼트 <ue-carousel> 하나만 정의한다. 외부 라이브러리를 쓰지 않는다.
   마크업 계약:
     <ue-carousel class="ue-car" data-axis="x" data-peek="7">
       <div class="ue-car__track" data-car-track> ...아이템... </div>
       <button class="ue-car__nav ue-car__nav--prev" data-car-prev aria-label="Previous">...</button>
       <button class="ue-car__nav ue-car__nav--next" data-car-next aria-label="Next">...</button>
     </ue-carousel>
   손가락 스와이프는 CSS 스크롤 스냅이 맡는다(ue-rhythm.css).
   마우스로 끌어서 미는 것은 브라우저가 안 해 주므로 이 파일이 붙인다(끌기붙이기). */

(function () {
  'use strict';

  if (!window.customElements || customElements.get('ue-carousel')) { return; }

  var EDGE = 2; /* 끝 판정 오차(px). 소수점 스크롤 위치 때문에 둔다 */


  /* ── 마우스로 끌어서 밀기 (2026-09-13 의장 「손으로 슬라이딩 되게 해봐」) ──
     손가락 스와이프는 원래 됐다(실측: 카테고리 줄 0 → 207px). 안 되던 것은 **마우스로 끄는 것**이다
     — 브라우저는 overflow 상자를 마우스로 끌어 주지 않는다(실측: 207 → 207, 꿈쩍 안 함).

     지키는 것
      · 마우스일 때만 붙인다. 손가락은 브라우저가 하는 일을 뺏지 않는다
      · 4px 넘게 움직였을 때만 「끈 것」으로 본다 — 그 아래는 그냥 누른 것이다
      · 끌고 나면 **그 다음 클릭 한 번을 막는다.** 안 막으면 상품을 끌었을 뿐인데 상세로 넘어간다
      · 끄는 동안 스크롤 스냅을 잠시 끈다. 켜 두면 칸에 자석처럼 붙어 따라오지 않는다 */
  var 끌린것 = 'ue-끌기붙음';

  function 끌기붙이기(track) {
    if (!track || track.dataset[끌린것] === '1' || !window.PointerEvent) { return; }
    track.dataset[끌린것] = '1';

    var 누름 = false, 끌었나 = false, 시작X = 0, 시작Y = 0, 시작스크롤 = 0, 원래스냅 = '';

    track.style.cursor = 'grab';

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) { return; }
      누름 = true; 끌었나 = false;
      시작X = e.clientX; 시작Y = e.clientY;
      시작스크롤 = track.scrollLeft;
      원래스냅 = track.style.scrollSnapType;
    });

    track.addEventListener('pointermove', function (e) {
      if (!누름) { return; }
      var dx = e.clientX - 시작X;
      if (!끌었나) {
        /* 세로로 더 많이 움직였으면 지면을 굴리려는 것이다 — 가로 끌기로 가로채지 않는다 */
        if (Math.abs(dx) <= 4 || Math.abs(e.clientY - 시작Y) > Math.abs(dx)) { return; }
        끌었나 = true;
        track.style.scrollSnapType = 'none';
        track.style.cursor = 'grabbing';
        track.style.userSelect = 'none';
        if (track.setPointerCapture) { track.setPointerCapture(e.pointerId); }
      }
      track.scrollLeft = 시작스크롤 - dx;
      e.preventDefault();
    });

    function 놓기(e) {
      if (!누름) { return; }
      누름 = false;
      track.style.cursor = 'grab';
      track.style.userSelect = '';
      if (!끌었나) { return; }

      /* 놓은 자리에서 **가장 가까운 칸**으로 붙이되, 조금이라도 끌었으면 한 칸은 넘어간다.
         스냅에만 맡기면 한 칸이 화면 폭만 한 히어로에서 **제자리로 되돌아온다**
         (실측: 1440에서 240px 끌었더니 1440 그대로). 실제 슬라이더들이 쓰는 방식대로
         「끈 거리가 한 칸의 10%를 넘으면 그 방향으로 한 칸」으로 판단한다. */
      /* 폭이 있는 자식만 센다. 상품 매대는 카드 사이사이에 폭 0짜리 <style> 이 끼어 있어
         (카드 24개 + style 24개 = 자식 48개) 앞의 둘을 그냥 집으면 칸폭이 거터 36px 로 잡힌다.
         그러면 300px 끌었는데 1368px 이 밀린다(실측 2026-09-13). */
      var 보이는칸 = [];
      for (var c = 0; c < track.children.length && 보이는칸.length < 2; c++) {
        if (track.children[c].getBoundingClientRect().width > 0) { 보이는칸.push(track.children[c]); }
      }
      var 칸폭 = (보이는칸.length === 2)
        ? (보이는칸[1].getBoundingClientRect().left - 보이는칸[0].getBoundingClientRect().left)
        : (보이는칸.length === 1 ? 보이는칸[0].getBoundingClientRect().width : track.clientWidth);
      if (!칸폭 || 칸폭 < 1) { 칸폭 = track.clientWidth || 1; }

      var 지금 = track.scrollLeft;
      var 끈거리 = 지금 - 시작스크롤;
      var 목표 = Math.round(지금 / 칸폭) * 칸폭;
      if (Math.abs(끈거리) > 칸폭 * 0.1 && 목표 === Math.round(시작스크롤 / 칸폭) * 칸폭) {
        목표 += (끈거리 > 0 ? 칸폭 : -칸폭);
      }
      var 최대 = track.scrollWidth - track.clientWidth;
      if (목표 < 0) { 목표 = 0; }
      if (목표 > 최대) { 목표 = 최대; }

      /* 스냅을 켠 채로 옮기면 스냅이 중간에 가로챈다 — 다 옮긴 뒤에 되살린다 */
      if (track.scrollTo) { track.scrollTo({ left: 목표, behavior: 'smooth' }); }
      else { track.scrollLeft = 목표; }
      window.setTimeout(function () { track.style.scrollSnapType = 원래스냅; }, 450);
      if (e && e.pointerId != null && track.releasePointerCapture && track.hasPointerCapture && track.hasPointerCapture(e.pointerId)) {
        track.releasePointerCapture(e.pointerId);
      }
      track.addEventListener('click', function 한번(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        track.removeEventListener('click', 한번, true);
      }, true);
      /* 클릭이 안 오는 경우(빈자리에서 놓음)를 대비해 다음 차례에 걷어낸다 */
      window.setTimeout(function () { 끌었나 = false; }, 0);
    }

    track.addEventListener('pointerup', 놓기);
    track.addEventListener('pointercancel', 놓기);
    track.addEventListener('dragstart', function (e) { if (끌었나) { e.preventDefault(); } });
  }

  /* 캐러셀 밖의 트랙(히어로 등)은 data-ue-drag 를 달아 두면 여기서 같이 붙는다 */
  function 밖에서찾기() {
    var 목록 = document.querySelectorAll('[data-ue-drag]');
    for (var i = 0; i < 목록.length; i++) { 끌기붙이기(목록[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', 밖에서찾기);
  } else {
    밖에서찾기();
  }

  function UeCarouselFactory() {
    class UeCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-car-track]');
        if (!this.track) { return; }

        this.prevBtn = this.querySelector('[data-car-prev]');
        this.nextBtn = this.querySelector('[data-car-next]');
        /* 점 표시 — 마크업에 빈 상자만 두면 여기서 개수를 채운다
           (2026-09-13 의장 「C로 가자」 — 카테고리 줄은 화살표 대신 점) */
        this.dotsBox = this.querySelector('[data-car-dots]');
        this.dotCount = -1;
        this.axis = this.getAttribute('data-axis') === 'y' ? 'y' : 'x';

        this.handleUpdate = this.update.bind(this);
        this.handlePrev = this.step.bind(this, -1);
        this.handleNext = this.step.bind(this, 1);
        this.handleDot = this.onDot.bind(this);

        this.track.addEventListener('scroll', this.handleUpdate, { passive: true });
        if (this.prevBtn) { this.prevBtn.addEventListener('click', this.handlePrev); }
        if (this.nextBtn) { this.nextBtn.addEventListener('click', this.handleNext); }

        if (window.ResizeObserver) {
          this.observer = new ResizeObserver(this.handleUpdate);
          this.observer.observe(this.track);
          /* 한 화면 개수(--ue-per)가 바뀌면 아이템 폭이 먼저 바뀐다 — 첫 아이템도 같이 본다 */
          if (this.track.firstElementChild) {
            this.observer.observe(this.track.firstElementChild);
          }
        } else {
          window.addEventListener('resize', this.handleUpdate);
        }

        끌기붙이기(this.track);

        this.루프깔기();

        this.update();
        /* 사진이 늦게 들어와 트랙 폭이 바뀌는 경우를 한 번 더 잡는다 */
        this.retryTimer = window.setTimeout(this.handleUpdate, 400);

        this.자동시작();
      }

      /* ── 자동 넘김 (2026-09-13 의장 「타임세일 구간은 자동으로 캐러셀이 움직이게」) ──
         `data-autoplay="5000"` 처럼 **밀리초**를 주면 그 간격으로 한 칸씩 넘어간다.
         값이 없으면 아무 일도 하지 않는다 — 다른 캐러셀은 그대로다.

         지키는 것
          · 끝에 닿으면 **처음으로 돌아간다.** 멈춰 있으면 자동이라 부를 수 없다
          · 손이 닿으면(마우스·손가락·키보드 초점) 멈추고, 떠나면 다시 간다
          · 화면 밖으로 나가면 멈춘다 — 안 보이는 것을 굴릴 이유가 없다
          · **「움직임 줄이기」를 켠 사용자에게는 아예 켜지 않는다**(접근성. 어지럼을 유발한다) */
      자동시작() {
        var 간격 = parseInt(this.getAttribute('data-autoplay') || '0', 10);
        if (!간격 || 간격 < 1500) { return; }

        /* ⚠ 「움직임 줄이기」를 켠 사용자에게도 돌린다 (2026-09-27 의장 지시 — 선택지 2번).
           원래는 여기서 멈췄다. 의장 화면에서 자동 넘김이 안 돈 원인이 이것이었고,
           실측으로 확인한 뒤 의장이 예외를 빼기로 정했다.
           ⛔ 접근성 판단을 되돌린 것이므로 **다음 사람이 「버그」로 보고 되살리지 않는다.**
              되살리려면 의장 지시가 있어야 한다. 근거는 SLOWRECIPE/CLAUDE.md 0-31절. */

        this.자동간격 = 간격;
        this.멈춤 = false;

        this.한칸 = function () {
          if (this.멈춤 || !this.track) { return; }
          if (this.루프) { this.step(1); return; }   /* 이음매는 루프 장치가 지운다 */
          var 끝 = this.track.scrollWidth - this.track.clientWidth - 2;
          if (this.track.scrollLeft >= 끝) {
            this.track.scrollTo({ left: 0, behavior: 'smooth' });   /* 처음으로 */
          } else {
            this.step(1);
          }
        }.bind(this);

        this.자동타이머 = window.setInterval(this.한칸, 간격);

        /* ⚠ `mouseenter` 는 **버블링하지 않는다.** 안쪽 카드에 마우스가 들어가면
           이 요소에서는 잡히지 않아 멈추지 않았다(2026-09-13 실측: 올려도 계속 넘어갔다).
           버블링하는 `mouseover`/`mouseout` 으로 바꾸고, 진짜로 밖으로 나갔을 때만 다시 움직인다. */
        this.세우기 = function () { this.멈춤 = true; }.bind(this);
        this.다시 = function (e) {
          /* 안쪽 요소끼리 옮겨 다니는 것은 「나감」이 아니다 */
          if (e && e.relatedTarget && this.contains(e.relatedTarget)) { return; }
          this.멈춤 = false;
        }.bind(this);
        ['mouseover', 'touchstart', 'focusin'].forEach(function (n) {
          this.addEventListener(n, this.세우기, { passive: true });
        }, this);
        ['mouseout', 'touchend', 'focusout'].forEach(function (n) {
          this.addEventListener(n, this.다시, { passive: true });
        }, this);

        if (window.IntersectionObserver) {
          this.보임감시 = new IntersectionObserver(function (들) {
            들.forEach(function (e) { this.멈춤 = !e.isIntersecting; }, this);
          }.bind(this), { threshold: 0.15 });
          this.보임감시.observe(this);
        }
      }

      자동멈춤() {
        if (this.자동타이머) { window.clearInterval(this.자동타이머); this.자동타이머 = null; }
        if (this.보임감시) { this.보임감시.disconnect(); }
        if (this.세우기) {
          ['mouseover', 'touchstart', 'focusin'].forEach(function (n) { this.removeEventListener(n, this.세우기); }, this);
          ['mouseout', 'touchend', 'focusout'].forEach(function (n) { this.removeEventListener(n, this.다시); }, this);
        }
      }

      disconnectedCallback() {
        if (this.track) {
          this.track.removeEventListener('scroll', this.handleUpdate);
        }
        if (this.prevBtn) { this.prevBtn.removeEventListener('click', this.handlePrev); }
        if (this.nextBtn) { this.nextBtn.removeEventListener('click', this.handleNext); }
        if (this.observer) { this.observer.disconnect(); }
        window.removeEventListener('resize', this.handleUpdate);
        if (this.retryTimer) { window.clearTimeout(this.retryTimer); }
        this.자동멈춤();
      }

      /* 축에 맞는 현재 위치 · 가시 크기 · 전체 크기 */
      /* ── 끝없이 도는 줄 (2026-09-27 의장 「돌다가 전체가 맨앞으로 확 돌아가는데 그러지말고
         하나씩 계속 들어오고 나가고 하게. 마지막이 첫 게시물로 이어지게」) ──

         방법: 원본을 **한 벌 더 복제해 뒤에 붙인다.** 끝을 지나면 보이는 것이 복제본인데
         원본과 똑같이 생겼으므로, 그때 스크롤을 원본 폭만큼 **조용히 되돌리면** 이음매가 안 보인다.
         「맨앞으로 확 돌아가는」 느낌이 사라지고 한 칸씩 계속 흘러간다.

         ⚠ 되돌리기를 스크롤 도중에 하면 **부드러운 이동이 끊겨 덜컥거린다.**
            그래서 스크롤이 멎은 뒤(150ms)에만 되돌린다 — 그 사이에 보이는 것은 복제본이라 티가 안 난다.
         ⚠ 복제본은 읽어 주는 장치에서 두 번 읽히면 안 된다 — aria-hidden 을 붙이고 초점에서 뺀다. */
      루프깔기() {
        if (!this.hasAttribute('data-loop')) { return; }
        if (this.axis !== 'x') { return; }

        var 원본 = [].slice.call(this.track.children).filter(function (e) {
          /* ⚠ 매대 트랙은 카드마다 폭 0 짜리 <style> 을 끼워 넣는다 (CLAUDE.md 0-20). 그것은 세지 않는다 */
          return e.getBoundingClientRect().width > 0;
        });
        if (원본.length < 2) { return; }

        this.루프 = true;
        원본.forEach(function (e) {
          var 사본 = e.cloneNode(true);
          사본.setAttribute('data-ue-clone', '');
          사본.setAttribute('aria-hidden', 'true');
          [].slice.call(사본.querySelectorAll('a,button,input,select,textarea')).forEach(function (f) {
            f.setAttribute('tabindex', '-1');
          });
          this.track.appendChild(사본);
        }, this);

        this.루프재기();
      }

      루프재기() {
        if (!this.루프) { return; }
        /* 원본 폭 = 전체의 절반. 복제를 한 벌만 붙이므로 정확히 반이다 */
        this.루프폭 = this.track.scrollWidth / 2;
      }

      /* 이음매를 지났으면 스크롤이 멎은 뒤 조용히 되돌린다 */
      이음매보기() {
        if (!this.루프 || !this.루프폭) { return; }
        var 자리 = this.track.scrollLeft;
        if (자리 < this.루프폭 - 1) { return; }
        if (this.이음매타이머) { window.clearTimeout(this.이음매타이머); }
        this.이음매타이머 = window.setTimeout(function () {
          var 지금 = this.track.scrollLeft;
          if (지금 >= this.루프폭 - 1) {
            var 옛동작 = this.track.style.scrollBehavior;
            this.track.style.scrollBehavior = 'auto';
            this.track.scrollLeft = 지금 - this.루프폭;
            this.track.style.scrollBehavior = 옛동작;
          }
        }.bind(this), 150);
      }

      metrics() {
        if (this.axis === 'y') {
          return {
            pos: this.track.scrollTop,
            view: this.track.clientHeight,
            total: this.track.scrollHeight
          };
        }
        if (this.루프 && this.루프폭) {
          return {
            pos: this.track.scrollLeft % this.루프폭,
            view: this.track.clientWidth,
            total: this.루프폭
          };
        }
        return {
          pos: this.track.scrollLeft,
          view: this.track.clientWidth,
          total: this.track.scrollWidth
        };
      }

      /* 가시폭(가시높이) 한 판씩 넘긴다 */
      /* 한 칸(카드 하나)의 폭 — 이웃한 두 아이템의 왼쪽 거리로 잰다. 거터까지 함께 들어간다.
         ⚠ 매대 트랙은 카드마다 폭 0 짜리 <style> 을 끼워 넣는다 (CLAUDE.md 0-20) — 폭이 있는 것만 센다. */
      한칸폭() {
        var 것 = [].slice.call(this.track.children).filter(function (e) {
          return e.getBoundingClientRect().width > 0;
        });
        if (!것.length) { return 0; }
        if (것.length >= 2) {
          var 거리 = 것[1].getBoundingClientRect().left - 것[0].getBoundingClientRect().left;
          if (거리 > 1) { return 거리; }
        }
        return 것[0].getBoundingClientRect().width;
      }

      step(direction) {
        if (this.루프 && this.루프폭 && direction < 0 && this.track.scrollLeft <= EDGE) {
          var 옛 = this.track.style.scrollBehavior;
          this.track.style.scrollBehavior = 'auto';
          this.track.scrollLeft = this.루프폭;
          this.track.style.scrollBehavior = 옛;
        }
        var m = this.metrics();
        /* data-step="item" 이면 한 판이 아니라 **카드 하나씩** 움직인다
           (2026-09-27 의장 「3개가 한꺼번에 돌지말고 카드 하나씩 움직이게」) */
        var 한칸 = this.한칸폭();
        var 걸음 = m.view;
        if (this.getAttribute('data-step') === 'item' && 한칸 > 1) { 걸음 = 한칸; }

        /* ── 가로는 **절대 위치**로 간다 (2026-10-19 · 소서 개선점 9번) ──
           종전에는 scrollBy 로 「지금 자리 + 한 칸」을 밀기만 했다. 지금 자리가
           카드 경계에서 어긋나 있으면(손가락 스와이프가 중간에 멈췄을 때) 그
           어긋남을 그대로 안고 가서 **앞 카드 꼬리가 왼쪽에 남는다.**
           크롬은 mandatory 스냅이 뒤에서 바로잡아 주지만 iOS 사파리는 프로그램이
           일으킨 스크롤 뒤에 다시 스냅을 걸지 않아 어긋난 채로 선다 — 소서가
           아이폰에서 본 것이 이것이다 (실측: 어긋남 22px → 33.5px 로 남았다).
           이제 **지금 보이는 카드를 먼저 찾아** 거기서 몇 칸 뒤 카드의 **실제
           좌표**로 간다. 그래서 어디서 눌러도 카드 경계에 정확히 선다. */
        var 것 = [].slice.call(this.track.children).filter(function (e) {
          return e.getBoundingClientRect().width > 0;
        });
        if (this.axis !== 'y' && 것.length >= 2 && 한칸 > 1) {
          /* 한 번에 몇 칸인가 — 한 판 걸음이면 한 판에 들어가는 칸 수만큼 */
          var 칸수 = Math.max(1, Math.round(걸음 / 한칸));
          /* 트랙 왼쪽 끝에 가장 가까운 카드가 「지금 카드」다 */
          var 기준 = this.track.getBoundingClientRect().left;
          var 지금 = 0, 최소 = Infinity;
          것.forEach(function (e, i) {
            var d = Math.abs(e.getBoundingClientRect().left - 기준);
            if (d < 최소 - 0.5) { 최소 = d; 지금 = i; }
          });
          var 갈곳 = Math.min(것.length - 1, Math.max(0, 지금 + 칸수 * direction));
          var 끝 = this.track.scrollWidth - this.track.clientWidth;   /* 루프 트랙은 m.total 이 루프폭이라 쓰면 안 된다 */
          var 목표 = this.track.scrollLeft + (것[갈곳].getBoundingClientRect().left - 기준);
          목표 = Math.max(0, Math.min(Math.round(목표), 끝));
          /* 옮기는 동안 스냅을 내려 둔다 — 켠 채로 두면 스냅이 중간에 가로챈다.
             끌기 쪽(놓기 함수)에서 이미 쓰는 방식 그대로다. 목표가 어차피 스냅 지점이라
             되살려도 다시 움직이지 않는다. */
          var 옛스냅 = this.track.style.scrollSnapType;
          this.track.style.scrollSnapType = 'none';
          if (this.스냅타이머) { window.clearTimeout(this.스냅타이머); }
          this.스냅타이머 = window.setTimeout(function () {
            this.track.style.scrollSnapType = 옛스냅;
          }.bind(this), 500);
          this.track.scrollTo({ left: 목표, behavior: 'smooth' });
          return;
        }

        var delta = 걸음 * direction;
        if (this.axis === 'y') {
          this.track.scrollBy({ top: delta, behavior: 'smooth' });
        } else {
          this.track.scrollBy({ left: delta, behavior: 'smooth' });
        }
      }

      update() {
        if (!this.track) { return; }
        if (this.루프 && !this.루프폭) { this.루프재기(); }
        var m = this.metrics();
        var scrollable = (m.total - m.view) > EDGE;

        this.dots();

        /* 아이템이 전부 보이면 화살표 두 개를 모두 숨긴다 */
        if (this.prevBtn) { this.prevBtn.hidden = !scrollable; }
        if (this.nextBtn) { this.nextBtn.hidden = !scrollable; }
        if (!scrollable) { return; }

        /* 끝없이 도는 줄에는 끝이 없다 — 흐리지 않는다 */
        if (this.루프) {
          if (this.prevBtn) { this.prevBtn.disabled = false; }
          if (this.nextBtn) { this.nextBtn.disabled = false; }
          this.이음매보기();
          return;
        }

        /* 끝에 닿으면 그 방향 버튼을 흐린다 */
        if (this.prevBtn) { this.prevBtn.disabled = m.pos <= EDGE; }
        if (this.nextBtn) { this.nextBtn.disabled = m.pos >= (m.total - m.view - EDGE); }
      }

      /* 점은 **아이템 개수가 아니라 판 개수**다.
         카테고리가 일곱이라고 점을 일곱 개 두면 줄줄이 늘어선다 —
         한 화면에 몇 개가 보이든 「몇 번 밀면 끝인가」가 사람이 세는 단위다. */
      dots() {
        if (!this.dotsBox) { return; }
        var m = this.metrics();
        var view = m.view || 1;

        /* ⛔ 판 개수는 **복제본을 뺀 진짜 칸 수**로 센다 (2026-09-30 사고).
           끝과 처음을 잇느라 칸을 통째로 복제해 두는데, 픽셀로 세면 그 복제본까지 세어진다.
           리뷰 30건짜리 구간에 **점이 62개** 나왔다. */
        var 칸폭 = this.한칸폭();
        var pages;
        if (칸폭 > 1) {
          var 진짜 = [].slice.call(this.track.children).filter(function (e) {
            /* 폭 0 짜리 <style> 과 복제본은 세지 않는다 (CLAUDE.md 0-20) */
            return e.getBoundingClientRect().width > 0 && !e.hasAttribute('data-ue-clone');
          }).length;
          var 한판 = Math.max(1, Math.round(view / 칸폭));
          pages = Math.max(1, Math.ceil(진짜 / 한판));
        } else {
          pages = Math.max(1, Math.ceil((m.total - EDGE) / view));
        }

        /* 점이 너무 많으면 **위치를 알려 주지 못한다** — 서른 개짜리 점 줄은 읽히지 않는다.
           열둘을 넘으면 감춘다 (2026-09-30 의장 ㉯). 좌우 화살표와 자동 넘김이 있어 기능은 그대로다. */
        if (pages < 2 || pages > 12) {
          this.dotsBox.hidden = true;
          return;
        }
        this.dotsBox.hidden = false;

        if (pages !== this.dotCount) {
          this.dotCount = pages;
          this.dotsBox.textContent = '';
          for (var i = 0; i < pages; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'ue-car__dot';
            b.setAttribute('data-car-dot', String(i));
            b.setAttribute('aria-label', 'Page ' + (i + 1));
            this.dotsBox.appendChild(b);
          }
          this.dotsBox.addEventListener('click', this.handleDot);
        }

        var now = Math.min(Math.round(m.pos / view), pages - 1);
        for (var d = 0; d < this.dotsBox.children.length; d++) {
          this.dotsBox.children[d].setAttribute('aria-selected', d === now ? 'true' : 'false');
        }
      }

      onDot(e) {
        var b = e.target.closest ? e.target.closest('[data-car-dot]') : null;
        if (!b) { return; }
        var i = parseInt(b.getAttribute('data-car-dot'), 10);
        var m = this.metrics();
        if (this.axis === 'y') { this.track.scrollTo({ top: i * m.view, behavior: 'smooth' }); }
        else { this.track.scrollTo({ left: i * m.view, behavior: 'smooth' }); }
      }
    }
    return UeCarousel;
  }

  customElements.define('ue-carousel', UeCarouselFactory());
})();
